module.exports = __webpack_public_path__ + "media/dashboard/assets/images/flow-new/end-flow-sign-7dab5b35a32382ea168fbbb2dea5252e.png";